export enum LoanStatus {
  Active = 0, //Aktivt
  Due = 1, //Forfaldent->Du har modtaget en opkrævning
  Transferred = 2, //Oversendt til Gældsstyrelsen-> Sendt til inddrivelse hos Gældsstyrelsen
  Paid = 3, //Afsluttet
  Stopped = 4, //Lån standset. Renter til løbende betaling
}
